"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _startsWith2 = _interopRequireDefault(require("lodash/fp/startsWith"));

var _history = require("relient/actions/history");

var _url = require("relient/url");

var _features = require("relient/features");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var _default = function _default(baseUrl) {
  return function () {
    return function (next) {
      return function (action) {
        var payload = action.payload,
            type = action.type;

        if (type === _history.PUSH && !(0, _startsWith2.default)('.')(payload) && !(0, _startsWith2.default)('/')(payload)) {
          return next(__assign(__assign({}, action), {
            payload: (0, _url.getWithBaseUrl)((0, _features.getFeatureBy)('link')(payload), baseUrl)
          }));
        }

        return next(action);
      };
    };
  };
};

exports.default = _default;